import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isPast'
})
export class IsPastPipe implements PipeTransform {

  transform(currentDate: any): boolean{
    return getIsPast(currentDate);
  }

}

function getIsPast(dateProvided): boolean {
  let date = new Date();
  let dayIs14FromHoliday = true;
  let d = date.getDate();
  let m = date.getMonth() + 1;
  let y = date.getFullYear();
  let todayDateString =
    (m <= 9 ? '0' + m : m) + '/' + (d <= 9 ? '0' + d : d) + '/' + y;

  let pastDate = Date.now() + -14 * 24 * 3600 * 1000;
  let pastDateMinus14 = new Date(pastDate);

  let past14Date = pastDateMinus14.toLocaleDateString;
  let dPast = pastDateMinus14.getDate();
  let mPast = pastDateMinus14.getMonth() + 1;
  let yPast = pastDateMinus14.getFullYear();
  let pastDateString =
    (mPast <= 9 ? '0' + mPast : mPast) +
    '/' +
    (dPast <= 9 ? '0' + dPast : dPast) +
    '/' +
    yPast;

  this.holidayDays.forEach((element) => {
    if (element === pastDateString) {
      dayIs14FromHoliday = true;
    } else {
      dayIs14FromHoliday = false;
    }
  });
  let isPastDate = false;
  let todayDate = new Date(todayDateString);
  let todayPlus14 = new Date(todayDate.setDate(todayDate.getDate() + 14));
  let providedDate = new Date(dateProvided);
  if (todayPlus14 > providedDate || dayIs14FromHoliday) {
    //||  dateProvided === '12/31/2019'
    isPastDate = true;
  } else {
    isPastDate = false;
  }
  return isPastDate;
}